<template>
  <textarea
    rows="4"
    class="block w-full p-2 placeholder-gray-400 border border-gray-300 rounded appearance-none bg-color"
    :value="value"
    v-on="listeners"
  ></textarea>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    listeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit("input", event.target.value);
        },
      });
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: inherit;
}
</style>
